export function SiteFooter () {

	return (
		<footer className="bg-gray-900">
	    	<div className="container mx-auto px-9 py-3" >
	    		<span className="font-mono text-white">&copy; {new Date().getFullYear()} Mad-Web.Ca</span>
	    	</div>
	    </footer>
  )
}